import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BenjiKIV} from "../../BenjiKIV";

/**
 * Created by Jerker Nord on 2023-01-11.
 */

export class BenjiKIVMaxWinRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;
    private _controller:SimplePresentationRunnerController;

    public shouldRun():boolean {
        return BenjiKIV.model.brokeBank;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        this._mainTL = gsap.timeline({
            onComplete : () => {
                this.complete();
            }
        });
        this._mainTL.add(BenjiKIV.maxWinView.getMaxWinTL(() => this.maxWinReadyToSkip()));
    }

    private maxWinReadyToSkip():void{
        this._controller.setSkipCallback(() => this.skip());
    }

    private skip():void {
        this._controller.setSkipCallback();
        BenjiKIV.maxWinView.endMaxWin();
        BenjiKIV.initialWinView.hideAndResetAllSpineAnimations();
        this._controller.finish();
    }

    private complete():void {
        //this._controller.finish();
    }
}